import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/public/helper.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StoresActionType } from 'src/app/stores/+state/stores.actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-upload-video',
  templateUrl: './upload-video.component.html',
  styleUrl: './upload-video.component.scss',
})
export class UploadVideoComponent implements OnInit, OnChanges, OnDestroy {
  @Input() currentVideoUrl: string;
  @Input() label: string;
  @Input() infoMessage: string;
  @Input() acceptedFormats: string = '.mp4, .webm, .mov';
  @Input() submitVideo: (file: File) => void;
  @Input() removeVideo: () => void;

  reelImage: Object;
  video: File;
  isUploading: boolean = false;
  private cachedImageUrl: { [key: string]: any } = {};
  private destroy$ = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private toastr: ToastrService,
    private helperService: HelperService,
    private sanitizer: DomSanitizer,
    private store: Store,
    private actions$: Actions,
  ) {}

  ngOnInit(): void {
    this.generateThumbnail(this.currentVideoUrl);
    this.setupUploadListeners();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupUploadListeners(): void {
    // Listen for upload success
    this.actions$
      .pipe(
        ofType(StoresActionType.UploadStoreVideoSuccess),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.isUploading = false;
      });

    // Listen for upload failure
    this.actions$
      .pipe(
        ofType(StoresActionType.UploadStoreVideoFailed),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.isUploading = false;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateThumbnail(this.currentVideoUrl);
  }

  generateThumbnail(videoUrl: string) {
    this.reelImage = null;
    if (videoUrl) {
      this.helperService.generateThumbnail(videoUrl).then((res) => {
        this.reelImage = this.getImage(res);
      });
    }
  }

  getImage(image: string) {
    if (!this.cachedImageUrl[image]) {
      this.cachedImageUrl[image] = this.sanitizer.bypassSecurityTrustStyle(
        `url('${image}')`,
      );
    }
    return this.cachedImageUrl[image];
  }

  selectVideo(event) {
    event.target.value = null;
  }

  uploadVideo(fileEvent: Event) {
    const fileInput = fileEvent.target as HTMLInputElement;

    if (fileInput?.files?.length) {
      this.video = fileInput.files[0];
      if (!this.video.type.startsWith('video/')) {
        this.toastr.error(
          `${this.translateService.instant('admin.store.events.invalidVideoFormat')}.`,
          'Upload failed!',
        );
        this.video = null;
        return;
      }

      this.isUploading = true;
      this.submitVideo(this.video);
    }
  }

  processRemoveVideo() {
    this.removeVideo();
  }
}
